export default __webpack_public_path__ + "static/media/1964.7721d7d2.jpg";